module.exports = __webpack_public_path__ + "media/images/flags/1x1/cck-2cb6240cc3bce1b0569395f1ec8f5e00.svg";